import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "compliance-dialog",
  templateUrl: "compliance-dialog.html",
  styleUrls: ["./compliance-dialog.scss"]
})
export class ComplianceDialog implements OnInit {
  constructor(private dialogRef: MatDialogRef<ComplianceDialog>) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }
}
